// extracted by mini-css-extract-plugin
module.exports = {"icon":"slider-button_icon__bKPLh","sr-only":"slider-button_sr-only__Wir_E"};